module.exports = __webpack_public_path__ + "img/location_setting_android_4.e4a68777.png";